import { BadgeModes } from 'types/badge-modes';
import { battleModeForPath, isClaimSelectSegment, isContributionsSegment, RESERVED_PATHS } from 'shared/lib/nav-paths';

/** Resolve shell mode from the URL so refresh doesn't flash the feed first. */
export const modeFromPathname = (pathname: string): BadgeModes => {
  const parts = pathname.split('/').filter(Boolean);
  const [seg0, seg1] = parts;
  if (seg0 === 'stats') return seg1 === 'hashes' ? 'badge_hashes' : 'stats';
  if (seg0 === 'battle') return battleModeForPath(seg1);
  if (!seg0) return 'splash';
  if (!seg1) {
    switch (seg0) {
      case 'leaderboard':
        return 'leaderboard';
      case 'explore':
        return 'explore';
      case 'create':
      case 'claim':
      case 'edit':
      case 'summary':
        return 'editing_profile';
      case 'gallery':
        return 'badge_gallery';
      default:
        return RESERVED_PATHS.has(seg0) ? 'splash' : 'collected';
    }
  }
  if (seg0 === 'gallery' && seg1 === 'journeys') return 'journey_gallery';
  if (seg0 === 'gallery') return 'badge_gallery';
  if (isContributionsSegment(seg1)) return 'submitted';
  if (seg1 === 'journeys') return 'journeys';
  if (seg1 === 'feed') return 'profile_feed';
  if (isClaimSelectSegment(seg1)) return 'editing_profile';
  return 'collected';
};
